export const asgardeoConfig = {
  signInRedirectURL: process.env.REACT_APP_SIGN_IN_URL,
  signOutRedirectURL: process.env.REACT_APP_SIGN_OUT_URL,
  clientID: process.env.REACT_APP_ASGARDEO_CLIENT_ID,
  baseUrl: process.env.REACT_APP_ASGARDEO_BASE_URL,
  scope: ['openid', 'profile', 'email', 'address', 'phone'],
};
